import { createSelector } from 'reselect'
import { AppState } from 'Store'

const selectCreativeEntries = (state: AppState) =>
	state.advertisement.creative.creative_list.entries
const selectCreativeList = (state: AppState) => state.advertisement.creative.creative_list
const selectTotal = (state: AppState) => state.advertisement.creative.creative_list.total_entries
const selectCreative = (state: AppState) => state.advertisement.creative.creative
const selectCurrentParams = (state: AppState) => state.advertisement.creative.requestParams
const selectOpenContr = (state: AppState) => state.advertisement.creative.openedCreative
const selectDict = (state: AppState) => state.advertisement.organization.dict
const selectCreativeForms = createSelector(selectDict, (dict) => dict.creatives?.forms)
const selectCreativeKinds = createSelector(selectDict, (dict) => dict.creatives?.kinds)

const getCreativeId = createSelector(selectCreativeList, (creat) => {
	return {
		...creat,
		entries: creat.entries.map((creat) => ({
			...creat,
			id: creat.id,
			name: `${creat.id} (${creat.urls} ${creat.description})`,
		})),
	}
})

export const creativeSelector = {
	selectCreativeEntries,
	selectCreativeList,
	selectTotal,
	selectCreative,
	selectCurrentParams,
	selectOpenContr,
	selectCreativeForms,
	getCreativeId,
	selectCreativeKinds,
}
